import { debounce } from "lodash";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import FormikEffect from "../forms/formik/FormikEffect.jsx";
import ProjectWizardSteppedForm from "../projectWizard/ProjectWizardSteppedForm.jsx";

class DebouncedFormikEffect extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    debounceTime: PropTypes.number
  };

  static defaultProps = {
    debounceTime: ProjectWizardSteppedForm.ESTIMATE_DEBOUNCE
  };

  debounceEstimateChange = debounce(
    this.props.onChange,
    this.props.debounceTime
  );

  onFormikChange = (prevFormikProps, formikProps) => {
    if (prevFormikProps.values === formikProps.values) return null;
    this.debounceEstimateChange(prevFormikProps, formikProps);
  };

  render = () => {
    return <FormikEffect onChange={this.onFormikChange} />;
  };
}

export default DebouncedFormikEffect;
